module.exports = __webpack_public_path__ + "img/picture3.1556829e.jpg";